import IconButton from '@Components/IconButton';
import { ActionEnum } from '@Policy/utils/types';
import { Flex, Select, Icon, Option, SelectProps } from '@tonic-one/react';
import { EditIcon } from '@tonic-one/react-icons';
import { ChangeEvent, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { actionTranslateMap } from '@Policy/AdvancedThreatProtection/PolicyTemplate/Components/shared';

export const EditableActionCell = (props: {
  action: ActionEnum;
  options: ActionEnum[];
  onActionChange: (action: ActionEnum) => void;
  onModalOpen: () => void;
  selectProps?: SelectProps;
}) => {
  const { action, options, onModalOpen, onActionChange, selectProps } = props;
  const { t } = useTranslation();

  useEffect(() => {
    if (!options.includes(action)) {
      onActionChange(options[0]);
    }
  }, [action, onActionChange, options]);

  return (
    <Flex width="100%" columnGap="2x" onClick={(e) => e.stopPropagation()}>
      <Select
        value={action}
        onChange={(e: ChangeEvent<HTMLSelectElement>) =>
          onActionChange(Number(e.target.value) as ActionEnum)
        }
        minWidth="150px"
        {...selectProps}
      >
        {options.map((value: ActionEnum, index) => {
          return (
            <Option key={`action-${index}-${value}`} value={value}>
              {t(actionTranslateMap[value])}
            </Option>
          );
        })}
      </Select>
      {[ActionEnum.tagSubject, ActionEnum.addDisclaimer].includes(action) && (
        <IconButton
          ml="auto"
          tooltipLabel={
            action === ActionEnum.addDisclaimer
              ? t('policy.riskAi.rule.action.editDisclaimer')
              : t('policy.riskAi.rule.action.editSubjectTag')
          }
          onClick={(e) => {
            e.stopPropagation();
            onModalOpen();
          }}
        >
          <Icon as={EditIcon} />
        </IconButton>
      )}
    </Flex>
  );
};
